const groupGameTypes = (gameTypes) => {
	const prefixCounts = {};
	gameTypes.forEach(gt => {
		const dash = gt.slug.indexOf('-');
		const prefix = dash > -1 ? gt.slug.slice(0, dash) : null;
		if (prefix) prefixCounts[prefix] = (prefixCounts[prefix] || 0) + 1;
	});

	const topLevel = [];
	const groups = {};

	gameTypes.forEach(gt => {
		const dash = gt.slug.indexOf('-');
		const prefix = dash > -1 ? gt.slug.slice(0, dash) : null;
		if (prefix && prefixCounts[prefix] > 1) {
			if (!groups[prefix]) groups[prefix] = [];
			groups[prefix].push(gt);
		} else {
			topLevel.push(gt);
		}
	});

	Object.keys(groups).forEach(prefix => {
		groups[prefix].sort((a, b) => a.name.localeCompare(b.name));
	});

	return { topLevel, groups };
};

export default groupGameTypes;
